'use client';

import { IcCloseCircle, IconButton, TextField, Typography } from '@musinsa/mds';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface LabeledTextFieldProps {
  label: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  maxLength?: number;
  count?: number;
  error?: string;
  helperText?: string;
  name?: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  className?: string;
}

export const LabeledTextField = forwardRef<HTMLInputElement, LabeledTextFieldProps>(
  (
    {
      label,
      placeholder,
      onChange,
      onBlur,
      onClear,
      maxLength,
      count = 0,
      error,
      helperText,
      name,
      value,
      defaultValue,
      disabled,
      className,
    },
    ref,
  ) => (
    <div className={twMerge(className, 'flex flex-col')}>
      <Typography variant="body14pxMed">{label}</Typography>

      <div className="flex flex-col gap-2 mt-2">
        <div className="relative inline-flex w-full">
          <TextField
            ref={ref}
            error={!!error} // boolean 값으로 변환
            className="w-full"
            placeholder={placeholder}
            onChange={onChange}
            onBlur={onBlur}
            maxLength={maxLength}
            name={name}
            value={value}
            defaultValue={defaultValue}
            disabled={disabled}
          />
          {onClear && (
            <IconButton
              type="button"
              className="absolute right-2 top-2"
              size="size20x20"
              onClick={onClear}
              aria-label="입력 내용 지우기"
            >
              <IcCloseCircle fillColor="gray-400" />
            </IconButton>
          )}
        </div>
      </div>

      <div className="flex justify-between items-center mt-2 gap-8">
        <div className="flex-1 inline-flex">
          {helperText && !error && (
            <Typography variant="textEtc11pxReg" colorScheme="gray-500" className="flex-1">
              {helperText}
            </Typography>
          )}
          {error && (
            <Typography variant="textEtc11pxReg" colorScheme="red" className="flex-1">
              {error}
            </Typography>
          )}
        </div>
        {maxLength && (
          <Typography variant="textEtc11pxReg" colorScheme="gray-500" className="shrink-0">
            {count}/{maxLength}
          </Typography>
        )}
      </div>
    </div>
  ),
);
